import React, { ReactNode } from 'react'

export type OverlayProps = {
  className: string
  children: ReactNode
  isOpen: boolean
}

export const Overlay = ({ children, className, isOpen }: OverlayProps) => (
  <>
    {isOpen ? (
      <>
        <div className={className}>{children}</div>
      </>
    ) : null}{' '}
  </>
)
export default Overlay
